<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()" v-tooltip="displayedTooltip" @click="handleClick">
    <div :class="b('email')">
      {{ displayedEmail }}
    </div>
    <div :class="b('balance')">
      <div v-if="isLoading" :class="b('balance-skeleton')"></div>
      <div v-else-if="error" :class="b('balance-error')">
        {{ $t("Ошибка") }}
      </div>
      <div v-else>{{ displayedBalance }} USDT</div>
    </div>
  </div>
</template>
